import { render, staticRenderFns } from "./AlgoliaSearchColumns.vue?vue&type=template&id=a05b955c&scoped=true&"
import script from "./AlgoliaSearchColumns.vue?vue&type=script&lang=js&"
export * from "./AlgoliaSearchColumns.vue?vue&type=script&lang=js&"
import style0 from "./AlgoliaSearchColumns.vue?vue&type=style&index=0&id=a05b955c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05b955c",
  null
  
)

export default component.exports